import styled from 'styled-components';
export const withPrivacy = (BaseComponent, overrides)=>{
    return styled(BaseComponent)`
    ${(props)=>props.private ? overrides : ''};
  `;
}; // check styles
